
define(function (require) {
    "use strict";

    var LE = require("app");

    var template = require("user-management-templates/agent-groups/agentGroupMoveLayout.tmpl");
    var Paging = require("ui/paging/Paging");
    var Button = require("ui/button/Button");

    var AgentGroupMoveLayout = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupMoveLayout = Marionette.Layout.extend({
            className: "agent-group-move-layout",
            template: template,
            ui: {
                viewContainer:         ".view-container",
                pagingContainer:       ".paging-container",
                moveButton:            ".button-move",
                cancelButton:          ".button-cancel"
            },
            regions: {
                gridRegion: ".table-container"
            },
            uiComponents: {
                moveBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.moveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState:Button.STATES.DISABLED
                    },
                    events: {
                        "click": "_move"
                    }
                },
                btnCancel: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_close"
                    }
                },
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.pagingContainer",
                        collection: "view.collection",
                        blockWrongPageNumber: true
                    },
                    events: {
                        "change:page": "_onPagingChange"
                    }
                }
            },

            initialize: function(options) {
                this._initialize(options);
            },

            _initialize: function(options) {
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.AGENT_GROUP_MOVE);
                this.collection = options.collection;
                this._bindEvents();
            },

            _bindEvents: function() {
                this.listenTo(this.collection ,"reset", this._onCollectionReset);
                this.listenTo(this, "page:closeButtonClick", this._close);
                this.listenTo(this.channel.vent, "agentGroupMove:rowSelectorClick", this._updateMoveButtonState);
            },

            _onCollectionReset: function() {
                // set correct paging
                var pagingInfo = this.collection.getPagerInfo();
                this.uiComponents.paging.setInfo(pagingInfo.currentPageNumber, pagingInfo.totalPages);
            },

            _onPagingChange: function(componentId, eventName, currentPageNumber) {
                LEUserManagement.logger.debug("_onPagingChange " + currentPageNumber, "AgentGroupMoveLayout:_onPagingChange");
                this.channel.trigger("paging:change", currentPageNumber);
            },

            _move: function () {
                LEUserManagement.logger.info("User clicked on 'done' button.", "AgentGroupMoveLayout::_done");
                this.channel.trigger("agentGroupMoveLayout:buttons:moveGroup");
            },

            _close: function () {
                this.channel.trigger("page:close");
            },

            _updateMoveButtonState: function(options) {
                if(options) {
                    this.uiComponents.moveBtn.setEnabled(options.isChecked);
                }
            }
        });

    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupMoveLayout;
});
